import React from 'react';
import { useFocused, useSelected, useSlateStatic } from 'slate-react';
import { removeLink } from '../../utils/link.js';
import styles from './LinkStyles.module.scss';
// import { expandPurple } from '../../../../assets/hostedassets';

const normalizeUrl = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return `https://${url}`;
    }
    return url;
};

const Link = ({ attributes, element, children }) => {
    const editor = useSlateStatic();
    const selected = useSelected();
    const focused = useFocused();

    // Support both 'url' and 'href' for backwards compatibility
    const linkUrl = element.url || element.href;

    if (!linkUrl) {
        console.warn('Link element has no URL:', element);
        return <span {...attributes}>{children}</span>;
    }

    const normalizedHref = normalizeUrl(linkUrl);
    return (
        <div className={styles.Link}>
            <a href={linkUrl} {...attributes} {...element.attr} target={element.target}>
                {children}
            </a>
            {selected && focused && (
                <div className={styles.LinkPopup} contentEditable={false}>
                    <a href={normalizedHref} target={'_blank'}>
                        Open Link
                    </a>
                    <div className={styles.RemoveLink} onClick={() => removeLink(editor)}>
                        Remove
                    </div>
                </div>
            )}
        </div>
    );
};

export default Link;
